export const ApplicantStates = {
	application_review: 'application_review',
	interested: 'interested',
	toInterview: 'toInterview',
	offer: 'offer',
	hired: 'hired',
	rejected: 'rejected'
};
